// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PanHorizontalIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PanHorizontalIcon" ref={forwardedRef} {...props}>
      <path d="M12 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
      <path d="m19 10-3.536 3.536-1.06-1.06L16.879 10l-2.475-2.474 1.06-1.061z" />
      <path d="m1 10 3.536-3.535 1.06 1.06L3.121 10l2.475 2.475-1.06 1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PanHorizontalIcon = /* @__PURE__ */ Object.assign(
  PanHorizontalIconComponent,
  { displayName: 'PanHorizontalIcon' },
);
